<template>
  <div class="main-prl">
    <mainpage></mainpage>
  </div>
</template>

<script>
import Mainpage from '@/components/mainpage.vue'

export default {
  components: { Mainpage },
  name: 'HomePage',
}
</script>
